{"environments":[{"identifier":"production","name":"Production","url":"client-api.atomic.io","workbenchUrl":"https://workbench.atomic.io"}]}